import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useAppSelector } from "../../store/hook";
import { primary, gray } from "../../theme/colors";

// Internal classification sentinels written to the `weekly_project_update` field
// by fsp-chron. They are NOT customer-facing copy, so we hide the banner for them
// (and for an empty/nil value). Only a real update is shown.
const HIDDEN_VALUES = [
  "Project Complete",
  "Project Cancelled",
  "Project Inactionable",
];

// The update is recomputed each Sunday evening for the week starting Monday, so
// label it with that Monday–Sunday range (in the viewer's local time).
const currentWeekRange = (): string => {
  const now = new Date();
  const monday = new Date(now);
  monday.setDate(now.getDate() - ((now.getDay() + 6) % 7)); // back to Monday
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  const fmt = (d: Date) =>
    d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  return `${fmt(monday)} - ${fmt(sunday)}`;
};

// Customer-facing project update, shown at the top of the pizza tracker. Its text
// comes from the Sunrise `weekly_project_update` project field. Presented as a
// normal update (no AI branding).
export const ProjectUpdateSummary = () => {
  const { fields } = useAppSelector((state) => state.portal || ({} as any));

  const summary = fields?.weekly_project_update as string | undefined;
  if (!summary || HIDDEN_VALUES.includes(summary.trim())) return null;

  return (
    <Paper
      sx={{
        border: `1px solid ${primary[200]}`,
        background: primary[25],
        borderRadius: { sm: "8px", xs: 0 },
        padding: 4,
      }}
    >
      <Stack gap="4px">
        <Typography fontWeight={600} fontSize="16px">
          Weekly project update ({currentWeekRange()})
        </Typography>
        <Typography variant="body2" sx={{ color: gray[700] }}>
          {summary}
        </Typography>
      </Stack>
    </Paper>
  );
};
